var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-form flex-grow-1 d-flex flex-column"},[(_vm.isLoading)?_c('div',{staticClass:"mt-4"},[_c('Spinner')],1):_vm._e(),(!_vm.isLoading && _vm.notification)?_c('NotificationForm',{attrs:{"notification":_vm.notification},on:{"submit":function($event){return _vm.onSubmit($event)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }